<template>
    <div class="pagination infoBox">
        <button
            @click.prevent="prev"
            v-show="prevPage !== null"
            class="button button--hollow button--pagination"
        > {{prevText}}
        </button>
        <button
            @click="changePage(prevPage)"
            v-show="prevPage !== null"
            class="button button--hollow button--pagination"
        >{{prevPage}}
        </button>
        <button
            class="button button--hollow button--pagination"
            :class="{'disabled': current_page}"
        ><b>{{current_page}}</b></button>
        <button
            @click="changePage(nextPage)"
            v-show="nextPage !== null"
            class="button button--hollow button--pagination"
        >{{nextPage}}
        </button>
        <button
            @click.prevent="next"
            v-show="nextPage !== null"
            class="button button--hollow button--pagination"
        > {{nextText}}
        </button>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import eventBus from "../courses/eventBus";

    export default {
        data: () =>{
            return{
                current_page: null,
            }
        },
        props: [
            'prevText',
            'nextText',
            'nextPage',
            'prevPage',
            'type'
        ],
        computed: {
            ...mapGetters([
                // 'refreshPages'
            ]),
            eventName: function () {
                switch (this.type) {
                    case 'lesson':
                        return 'changePageLesson'
                        break
                    case 'theme':
                        return 'changePageTheme'
                        break
                    case 'lesson_items':
                        return 'changePageLessonItems'
                        break
                    case 'document_items':
                        return 'changePageDocumentItems'
                        break
                    case 'payment_items':
                        return 'changePagePaymentItems'
                        break
                    default:
                        break;
                }
            }
        },
        methods: {
            next() {
                this.$emit(this.eventName, {
                    page: this.nextPage
                })
                this.setPageToUrl(this.nextPage)
            },
            prev() {
                this.$emit(this.eventName, {
                    page: this.prevPage,
                })
                this.setPageToUrl(this.prevPage)
            },
            changePage(page) {
                this.$emit(this.eventName, {
                    page: page,
                })
                this.setPageToUrl(page)
            },
            setPageToUrl(page) {
                let url = new URL(window.location)

                if (page === undefined) {
                    page = url.searchParams.get('page') ? url.searchParams.get('page') : 1
                }

                if (url.searchParams.get('page') === null) {
                    url.searchParams.append('page', page)
                } else {
                    url.searchParams.set('page', page)
                }
                this.current_page = page
                window.history.pushState({path: url.href}, '', url.href);
            }
        },
        created() {
            this.setPageToUrl()
        },
        mounted() {
            eventBus.$on('change_page', data => {
                this.current_page = data
            })
        },
        watch: {
            // refreshPages() {
            //     this.changePage(1)
            // }
        },
        beforeDestroy() {
            eventBus.$off();
        }
    }
</script>

<style scoped>

</style>
